import { FC } from 'react';

import { FormSelect } from '@argenta/react-ui';
import { t } from '@lingui/macro';

import { useLanguage } from '../../hooks/useLanguage';

import { PostalCodeInputProps } from './PostalCodeInput.types';
import zipcodesFr from './data/zipcodes.fr.json';
import zipcodesNl from './data/zipcodes.nl.json';

import './PostalCodeInput.styles.scss';

export const PostalCodeInput: FC<PostalCodeInputProps> = ({ name }) => {
  const { language } = useLanguage();

  // Render Methods
  // ---------------------------------------------------------------------- ?
  return (
    <FormSelect
      name={name}
      i18nStrings={{
        placeholderText: t({ id: 'vacancies.search.postalCode.placeholder' }),
        searchText: '',
        emptyText: t({ id: 'vacancies.search.postalCode.noOptionsMessage' }),
      }}
      isClearable
      isSearchable
      options={language === 'nl' ? zipcodesNl.zipcodes : zipcodesFr.zipcodes}
      filterOption={(data, input) => {
        const [postalCode, city] = data.label
          .split(/-(.*)/)
          .map((value) => value.trim().toLowerCase());
        const inputLowerCase = input.toLowerCase();

        return (
          city.startsWith(inputLowerCase) ||
          postalCode.startsWith(inputLowerCase) ||
          data.label.toLowerCase().startsWith(inputLowerCase)
        );
      }}
    />
  );
};
